import { pick, omit } from 'lodash-es'
import { AddressFormData } from 'modules/checkout/types'

const emptyValue = ''
const emptyBillingAddress = {
  firstname: emptyValue,
  lastname: emptyValue,
  telephone: emptyValue,
  postcode: emptyValue,
  city: emptyValue,
  country_code: undefined,
  street: [emptyValue, ''],
  vat_id: undefined,
  customer_notes: emptyValue,
}

const noInvoiceBillingAddress = (data: AddressFormData) => {
  const countryCode = data.shipping_address.country_code
  const dataForAbroadInvoice = countryCode !== 'PL' ? data.shipping_address : {}
  return {
    ...emptyBillingAddress,
    ...dataForAbroadInvoice,
    email: data.email,
    country_code: countryCode,
    isInvoice: null,
    city: data.shipping_address.city,
    postcode: data.shipping_address.postcode,
    street: data.shipping_address.street,
    firstname: data.shipping_address.firstname,
    lastname: data.shipping_address.lastname,
    telephone: data.shipping_address.telephone,
    region_id: data.shipping_address.region_id,
  }
}

const invoiceBillingAddress = (data: AddressFormData) => {
  const output = {
    ...emptyBillingAddress,
    ...data.shipping_address,
    ...data.billing_address,
    is_invoice: data.shipping_address.country_code === 'PL' ? data.billing_address.invoice_type === 'company' ? 'business' : 'person' : null,
    telephone: data.shipping_address.telephone,
    firstname: data.billing_address.firstname || data.shipping_address.firstname,
    lastname: data.billing_address.lastname || data.shipping_address.lastname,
  }

  const companyInvoiceFields = ['company', 'vat_id']
  const omitFields =
    data.billing_address.invoice_type !== 'company' ? companyInvoiceFields : []
  return omit(output, omitFields)
}

const getBillingData = (data: AddressFormData, isInvoice) => {
  return isInvoice ? invoiceBillingAddress(data) : noInvoiceBillingAddress(data)
}

export const getBillingAddressVariables = (data: AddressFormData, isInvoice = false) => {
  const billingAddress = getBillingData(data, isInvoice)

  return {
    billingAddress: {
      address: {
        ...pick(billingAddress, [
          'firstname',
          'lastname',
          'telephone',
          'street',
          'vat_id',
          'postcode',
          'city',
          'country_code',
          'company',
          'is_invoice',
          'region',
          'region_id',
        ]),
      },
    },
  }
}
